/**
 * lenis-init.js
 * Central smooth-scroll controller for 108 Luxury.
 *
 * Architecture:
 *   Lenis → gsap.ticker → ScrollTrigger.update() → existing GSAP animations
 */

(function () {
  'use strict';

  // ── Idempotency Guard ────────────────────────────────────────────────────────
  if (window.__lenisReady) return;
  window.__lenisReady = true;

  // ── Skip if prefers-reduced-motion ───────────────────────────────────────────
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    console.log('[Lenis] prefers-reduced-motion — skipping.');
    return;
  }

  // ── Check dependencies ───────────────────────────────────────────────────────
  if (typeof window.Lenis === 'undefined') {
    console.warn('[Lenis] Lenis not found on window. Check CDN script.');
    return;
  }
  if (typeof window.gsap === 'undefined') {
    console.warn('[Lenis] GSAP not found. Check CDN script.');
    return;
  }
  if (typeof window.ScrollTrigger === 'undefined') {
    console.warn('[Lenis] ScrollTrigger not found. Check CDN script.');
    return;
  }

  // ── Register GSAP plugins ────────────────────────────────────────────────────
  gsap.registerPlugin(ScrollTrigger);
  gsap.ticker.lagSmoothing(0);

  // ── Init Lenis ───────────────────────────────────────────────────────────────
  var lenis = new Lenis({
    duration: 1.2,
    easing: function (t) {
      return Math.min(1, 1.001 - Math.pow(2, -10 * t));
    },
    smoothWheel: true,
  });

  window.lenisInstance = lenis;

  // ── Connect Lenis → GSAP ticker (single RAF loop) ────────────────────────────
  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add(function (time) {
    lenis.raf(time * 1000);
  });

  // ── Anchor links ──────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var anchor = e.target.closest('a[href^="#"]');
    if (!anchor) return;
    var id = anchor.getAttribute('href');
    if (!id || id === '#') return;
    var el = document.querySelector(id);
    if (!el) return;
    e.preventDefault();
    var header = document.querySelector('.header-wrapper, header[class]');
    var offset = header ? -(header.offsetHeight) : 0;
    lenis.scrollTo(el, { offset: offset, duration: 1.2 });
  }, { passive: false });

  // ── Shopify Theme Editor ───────────────────────────────────────────────────────
  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () { ScrollTrigger.refresh(); lenis.resize(); }, 300);
  });
  document.addEventListener('shopify:section:reorder', function () {
    setTimeout(function () { ScrollTrigger.refresh(); lenis.resize(); }, 300);
  });

  console.log('[Lenis] ✅ Initialized successfully');

})();
